import React from 'react';
import { Card, CardBody } from 'reactstrap';
import SyncFileDropzone from '../SyncFileDropzone/SyncFileDropzone';

import './SyncFileImportSection.css';

/**
 * Shared Synchronisation import layout:
 * title (+ optional float-right download) → help → dropzone → formats → children.
 *
 * @param {{
 *   title?: React.ReactNode,
 *   help?: React.ReactNode,
 *   formats?: React.ReactNode,
 *   accept?: string,
 *   disabled?: boolean,
 *   fileName?: string,
 *   hint?: string,
 *   onFile?: (file: File) => void,
 *   downloadSlot?: React.ReactNode,
 *   showDropzone?: boolean,
 *   children?: React.ReactNode,
 *   className?: string,
 * }} props
 */
const SyncFileImportSection = ({
    title,
    help,
    formats,
    accept,
    disabled,
    fileName,
    hint,
    onFile,
    downloadSlot,
    showDropzone = true,
    children,
    className,
}) => (
    <Card className={`mb-3 SyncFileImportSection${className ? ` ${className}` : ''}`}>
        <CardBody className="SyncFileImportSection-body">
            {(title || downloadSlot) ? (
                <div className="SyncFileImportSection-header">
                    {title ? <h5 className="SyncFileImportSection-title">{ title }</h5> : null}
                    {downloadSlot ? (
                        <div className="SyncFileImportSection-headerActions">
                            { downloadSlot }
                        </div>
                    ) : null}
                </div>
            ) : null}
            {help ? (
                typeof help === 'string'
                    ? <p className="SyncFileImportSection-help mb-3">{ help }</p>
                    : <div className="SyncFileImportSection-help mb-3">{ help }</div>
            ) : null}
            {showDropzone ? (
                <SyncFileDropzone
                    accept={ accept }
                    disabled={ disabled }
                    fileName={ fileName }
                    hint={ hint }
                    onFile={ onFile }
                />
            ) : null}
            {showDropzone && formats ? (
                <p className="small SyncFileImportSection-formats">
                    { formats }
                </p>
            ) : null}
            { children }
        </CardBody>
    </Card>
);

export default SyncFileImportSection;
